import type { CustomIconProps } from '../CustomIcon';

export const BriefcaseIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  size = 24,
  solid,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      {...props}>
      <path
        d='M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Z'
        fill={solid ? color : 'none'}
        stroke={solid ? color : secondaryColor}
      />
      <path d='M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16' stroke={secondaryColor} />
    </svg>
  );
};
